import React from "react";
import { Link } from "react-router-dom";
import { Button } from "../../ui";
const TermandConditions = () => {
  return (
    <div>
      <header
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "20px",
          backgroundColor: "#f1f1f1",
          borderBottom: "2px solid #ddd",
        }}
      >
        <div>
          <img
            src="/images/headericon.png"
            alt="Logo"
            style={{
              width: "60px",
              height: "60px",
              marginRight: "20px",
            }}
          />
        </div>

        <div>
          <Link to="/signup">
            <Button>Back</Button>
          </Link>
        </div>
      </header>
      <div
        style={{
          maxWidth: "auto",
          margin: "0 auto",
          padding: "20px",
          backgroundColor: "#f9f9f9",
          borderRadius: "10px",
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
        }}
        className="pl-5 pr-5"
      >
        <header style={{ textAlign: "center", marginBottom: "20px" }}>
          <h1
            style={{
              fontSize: "2.5rem",
              color: "#333",
              fontFamily: "Arial, sans-serif",
              letterSpacing: "1.5px",
            }}
          >
            Terms and Conditions
          </h1>
        </header>

        <section
          style={{
            fontFamily: "Open Sans, sans-serif",
            color: "#555",
            lineHeight: "1.8",
            fontSize: "1rem",
          }}
        >
          <h4
            style={{
              fontSize: "1.25rem",
              color: "#333",
              marginTop: "25px",
              marginBottom: "10px",
              textTransform: "uppercase",
              letterSpacing: "0.5px",
              fontWeight: "bold",
            }}
          >
            Welcome to the College Sports Fan Association (CSFA-US)
          </h4>
          <p>
            By using our website (
            <a
              href="http://www.csfa-us.com"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#007BFF", textDecoration: "none" }}
            >
              www.csfa-us.com
            </a>
            ), you agree to comply with these Terms and Conditions. Please read
            them carefully.
          </p>

          <h4
            style={{
              fontSize: "1.25rem",
              color: "#333",
              marginTop: "25px",
              marginBottom: "10px",
              textTransform: "uppercase",
              letterSpacing: "0.5px",
              fontWeight: "bold",
            }}
          >
            1. Acceptance of Terms
          </h4>
          <p>
            By accessing and using our platform, including live score updates,
            chat rooms, forums, and polls, you agree to be bound by these terms,
            along with our Privacy Policy. If you do not agree with any part of
            these terms, please refrain from using the site.
          </p>

          <h4
            style={{
              fontSize: "1.25rem",
              color: "#333",
              marginTop: "25px",
              marginBottom: "10px",
              textTransform: "uppercase",
              letterSpacing: "0.5px",
              fontWeight: "bold",
            }}
          >
            2. Eligibility
          </h4>
          <p>
            The CSFA-US platform is intended for users who are at least 13 years
            of age. If you are under 13, you are not permitted to register for
            or use any interactive elements, such as chat rooms or forums,
            without verifiable parental consent.
          </p>

          <h4
            style={{
              fontSize: "1.25rem",
              color: "#333",
              marginTop: "25px",
              marginBottom: "10px",
              textTransform: "uppercase",
              letterSpacing: "0.5px",
              fontWeight: "bold",
            }}
          >
            3. User Account
          </h4>
          <p>
            <strong style={{ color: "#333" }}>Registration:</strong> To
            participate in certain areas of the site (e.g., forums, voting, chat
            rooms), you may need to create an account.
          </p>
          <p>
            <strong style={{ color: "#333" }}>Responsibility:</strong> You are
            responsible for maintaining the confidentiality of your account
            login details.
          </p>
          <p>
            <strong style={{ color: "#333" }}>Termination:</strong> CSFA-US
            reserves the right to suspend or terminate your account at any time
            for violations.
          </p>

          <h4
            style={{
              fontSize: "1.25rem",
              color: "#333",
              marginTop: "25px",
              marginBottom: "10px",
              textTransform: "uppercase",
              letterSpacing: "0.5px",
              fontWeight: "bold",
            }}
          >
            4. Use of Services
          </h4>
          <p>
            <strong style={{ color: "#333" }}>4.1 Live Score Updates:</strong>{" "}
            We provide real-time updates for Football, Basketball, and Baseball,
            but delays may occur.
          </p>
          <p>
            <strong style={{ color: "#333" }}>
              4.2 Forums and Chat Rooms:
            </strong>{" "}
            Participate respectfully and avoid prohibited behaviors such as
            harassment, false information, or spam.
          </p>
          <p>
            <strong style={{ color: "#333" }}>4.3 Polls and Voting:</strong>{" "}
            Participate in fan polls honestly, and refrain from attempts to
            manipulate or rig votes.
          </p>

          <h4
            style={{
              fontSize: "1.25rem",
              color: "#333",
              marginTop: "25px",
              marginBottom: "10px",
              textTransform: "uppercase",
              letterSpacing: "0.5px",
              fontWeight: "bold",
            }}
          >
            5. Content Ownership and Usage Rights
          </h4>
          <p>
            <strong style={{ color: "#333" }}>
              5.1 User-Generated Content:
            </strong>{" "}
            By submitting content (e.g., forum posts), you grant CSFA-US a
            non-exclusive license to use it.
          </p>
          <p>
            <strong style={{ color: "#333" }}>5.2 CSFA-US Content:</strong> All
            other content on the website is protected by copyright laws.
          </p>

          <h4
            style={{
              fontSize: "1.25rem",
              color: "#333",
              marginTop: "25px",
              marginBottom: "10px",
              textTransform: "uppercase",
              letterSpacing: "0.5px",
              fontWeight: "bold",
            }}
          >
            6. Third-Party Links and Services
          </h4>
          <p>
            Our platform may contain links to external websites, and CSFA-US is
            not responsible for third-party content, privacy practices, or
            services.
          </p>

          <h4
            style={{
              fontSize: "1.25rem",
              color: "#333",
              marginTop: "25px",
              marginBottom: "10px",
              textTransform: "uppercase",
              letterSpacing: "0.5px",
              fontWeight: "bold",
            }}
          >
            7. Limitation of Liability
          </h4>
          <p>
            CSFA-US provides the platform on an "as is" basis and makes no
            warranties regarding the accuracy or availability of services.
          </p>

          <h4
            style={{
              fontSize: "1.25rem",
              color: "#333",
              marginTop: "25px",
              marginBottom: "10px",
              textTransform: "uppercase",
              letterSpacing: "0.5px",
              fontWeight: "bold",
            }}
          >
            8. Indemnification
          </h4>
          <p>
            By using the site, you agree to indemnify and hold CSFA-US harmless
            from claims arising from your use of the platform.
          </p>

          <h4
            style={{
              fontSize: "1.25rem",
              color: "#333",
              marginTop: "25px",
              marginBottom: "10px",
              textTransform: "uppercase",
              letterSpacing: "0.5px",
              fontWeight: "bold",
            }}
          >
            9. Changes to Terms
          </h4>
          <p>
            CSFA-US may revise these Terms and Conditions at any time. Continued
            use of the platform signifies your acceptance of updated terms.
          </p>

          <h4
            style={{
              fontSize: "1.25rem",
              color: "#333",
              marginTop: "25px",
              marginBottom: "10px",
              textTransform: "uppercase",
              letterSpacing: "0.5px",
              fontWeight: "bold",
            }}
          >
            10. Governing Law
          </h4>
          <p>
            These terms are governed by the laws of [State/Country]. Any legal
            disputes will be resolved in the courts of [State/Country].
          </p>

          <h4
            style={{
              fontSize: "1.25rem",
              color: "#333",
              marginTop: "25px",
              marginBottom: "10px",
              textTransform: "uppercase",
              letterSpacing: "0.5px",
              fontWeight: "bold",
            }}
          >
            11. Contact Information
          </h4>
          <p>
            If you have any questions or concerns regarding these Terms and
            Conditions, please contact us at:
            <br /> Email: support@csfa-us.com
            <br /> Phone: (123) 456-7890
            <br /> Mailing Address: College Sports Fan Association, 1234 Sports
            Ave, City, State, ZIP
          </p>
        </section>
      </div>
    </div>
  );
};

export default TermandConditions;
